import { useEffect } from 'react';

const useSetFocus = (inputField) =>{

    useEffect(()=>{
        document.querySelector(inputField).focus();
    },[])
}

export default useSetFocus;

